import styled from "styled-components";

export const Wrapper = styled.button`
  border: 0;
  outline: 0;
  background: var(--fill-secondary);
  display: flex;
  align-items: center;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  color: var(--text-primary);
  img {
    width: 100%;
    height: 100%;
    filter: invert(var(--svg-invert));
  }
`;

export const ThemeButtonRight = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.16px;
  color: var(--text-secondary);
`;

export const ModalWrapper = styled.div`
  position: absolute;
  background: var(--background-overflay);
  backdrop-filter: blur(8px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  z-index: 999;
  @media (min-width: 1024px) {
    width: 378px;
    right: 0;
    left: auto;
    height: 410px;
    background: transparent;
    backdrop-filter: none;
  }
`;

export const ModalBody = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  padding: 32px 24px 24px;
  color: var(--text-primary);

  &::before {
    content: " ";
    position: absolute;
    transition: 200ms ease-out;
    background: var(--background-elevated);
    color: var(--text-primary);
    border-radius: 32px 32px 0 0;
    box-shadow: 0px 8px 32px rgba(51, 20, 0, 0.16);
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    height: 100%;
    z-index: -1;
    @media (min-width: 1024px) {
      border-radius: 32px;
      transition: 0ms ease-out;
    }
  }
  &::after {
    content: " ";
    position: absolute;
    left: 50%;
    border-radius: 2px;
    background: var(--fill-secondary);
    top: 10px;
    transform: translateX(-50%);
    width: 32px;
    height: 4px;
    @media (min-width: 1024px) {
      display: none;
    }
  }

  &.theme-select::before {
    height: 312px;
  }

  @media (min-width: 1024px) {
    max-width: 360px;
    border-radius: 32px;
    top: 48px;
    bottom: auto;
  }
`;

export const ThemeModalHeading = styled.div`
  position: relative;
  text-align: center;
  font-size: 20px;
  font-variation-settings: "wght" 700;
  line-height: 1.2;
  letter-spacing: 0.4px;
  margin-bottom: 24px;
`;

export const ThemeSelect = styled.button`
  border: 0;
  outline: 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1;
  padding: 14px 0;
  width: 100%;
  background: transparent;
  color: var(--text-primary);
  height: 48px;
  img {
    filter: invert(var(--svg-invert));
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  & + & {
    margin-top: 16px;
  }
`;
